import { render, staticRenderFns } from "./checklRiskArea.vue?vue&type=template&id=5e03895f&scoped=true&"
import script from "./checklRiskArea.vue?vue&type=script&lang=js&"
export * from "./checklRiskArea.vue?vue&type=script&lang=js&"
import style0 from "./checklRiskArea.vue?vue&type=style&index=0&id=5e03895f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03895f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e03895f')) {
      api.createRecord('5e03895f', component.options)
    } else {
      api.reload('5e03895f', component.options)
    }
    module.hot.accept("./checklRiskArea.vue?vue&type=template&id=5e03895f&scoped=true&", function () {
      api.rerender('5e03895f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/dialogs/checklRiskArea.vue"
export default component.exports